import { type ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "~/router/routes";
import { useSignUpStore } from "~/stores";

export const ProtectedAdminRoute = ({ children }: { children?: ReactNode }) => {
  const { hasRequiredPatientFields } = useSignUpStore();

  if (!hasRequiredPatientFields()) {
    return <Navigate to={ROUTES.adminSignUp} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};
